import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import reactHtmlParser, { convertNodeToElement } from 'react-html-parser';

class HtmlComponent extends Component {
    constructor(props) {
        super(props);
        this.transform = this.transform.bind(this);
    }

    transform(node, index) {
    }

    renderHtml() {
        if(this.props.text) {
            return reactHtmlParser(this.props.text, {
                transform: this.transform,
            });
        }
    }

    render() {
        return (
            <Fragment>
                {this.props.inline ? <span className="html-text-wrapper">{this.renderHtml()}</span> : <div className="html-text-wrapper">{this.renderHtml()}</div>}
            </Fragment>
        );
    }
}

HtmlComponent.defaultProps = {
    inline: false,
};

HtmlComponent.propTypes = {
    text: PropTypes.string.isRequired,
    inline: PropTypes.bool,
};

export default HtmlComponent;
